import { useMemo } from "react";
import { useGetCountries } from "../../../../api/static-data";

/**
 * Register and Edit call useGetCountries() directly (not via useFacilitySourceTypeOptions) so
 * the Details drawer — which receives `countries` as a prop, matching legacy — never fetches it.
 */
export const useFacilityCountryOptions = () => {
  const { data: countriesData, isLoading: isCountriesLoading } = useGetCountries();

  const countryOptions = useMemo(
    () => (countriesData ?? []).map((c: any) => ({ id: c.id, title: c.country, value: c.id })),
    [countriesData]
  );

  return { countryOptions, isCountriesLoading };
};
